export enum StorageEnum {
  SESSION = 'SESSION',
  LOCAL = 'LOCAL',
  MEMORY = 'MEMORY'
}
